const setMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content || '');
};

export const setSEO = ({ title, description, image, url, type = 'website' } = {}) => {
    const t = title || 'Events Directory';
    const d = description || 'Browse and discover events';
    const u = url || window.location.href;

    document.title = t;
    setMeta('name', 'description', d);
    setMeta('property', 'og:title', t);
    setMeta('property', 'og:description', d);
    setMeta('property', 'og:url', u);
    setMeta('property', 'og:type', type);
    if (image) setMeta('property', 'og:image', image);
    setMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    setMeta('name', 'twitter:title', t);
    setMeta('name', 'twitter:description', d);
    if (image) setMeta('name', 'twitter:image', image);
};

export const setJSONLD = (data) => {
    let el = document.getElementById('json-ld-schema');
    if (!el) {
        el = document.createElement('script');
        el.id = 'json-ld-schema';
        el.type = 'application/ld+json';
        document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
};

export const clearJSONLD = () => {
    const el = document.getElementById('json-ld-schema');
    if (el) el.remove();
};
